export default "__VITE_ASSET__DRE$h1TE__"